module.exports = __webpack_public_path__ + "assets/img/AB.2b6469a0.svg";